module.exports = __webpack_public_path__ + "img/quest_icon_0050_food.a4d08c7e.png";